// src/components/routing/ProtectedRoute.tsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../context/UserContext";
import styles from "./ProtectedRoute.module.scss";

const ProtectedRoute: React.FC = () => {
  const { user, loading } = useUser();

  // While loading (checking cookie/session), show a loading spinner
  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner} aria-label="Loading" role="status" />
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  // Otherwise render child routes
  return <Outlet />;
};

export default ProtectedRoute;
